import { DashboardCardLinkButton } from '../../storageDashboard/DashboardCardLinkButton';
import type { PatientTrackingDashboardSummary } from './patientTrackingDashboardTypes';
import {
  formatDashboardTimestamp,
  patientStatusLabel,
  truncateIssueText
} from './patientTrackingDashboardFormatters';

interface PharmacyTrackerHealthCardProps {
  summary: PatientTrackingDashboardSummary;
  openHref: string;
}

export function PharmacyTrackerHealthCard({ summary, openHref }: PharmacyTrackerHealthCardProps) {
  const totalAttention = summary.followUpCount + summary.overdueAlertCount + summary.pendingCount;

  return (
    <section className="dashboard-card dashboard-card--attention">
      <div className="dashboard-card__header">
        <div>
          <h3 className="dashboard-card__title">Tracker Health</h3>
          <p>Open issues that may need pharmacy review</p>
        </div>
        <DashboardCardLinkButton text="Open Tracker" href={openHref} />
      </div>

      <div className="dashboard-attention-total">
        <span>{totalAttention}</span>
        <small>Total item(s)</small>
      </div>

      <div className="dashboard-attention-grid">
        <div>
          <strong>{summary.followUpCount}</strong>
          <span>Follow up</span>
        </div>
        <div>
          <strong>{summary.overdueAlertCount}</strong>
          <span>Overdue alerts</span>
        </div>
        <div>
          <strong>{summary.pendingCount}</strong>
          <span>Pending</span>
        </div>
      </div>

      <div className="dashboard-card__section">
        <h4 className="dashboard-card__section-title">Issues Needing Attention</h4>
        {summary.attentionItems.length === 0 ? (
          <p className="dashboard-empty">No issues need attention right now.</p>
        ) : (
          <ul className="dashboard-upcoming-list">
            {summary.attentionItems.slice(0, 5).map((item) => (
              <li key={item.id}>
                <span>
                  <strong>{item.patientName}</strong>
                  <small>
                    {item.coveredEntityName} · {item.reasons.join(' · ')} ·{' '}
                    {patientStatusLabel(item.status)}
                  </small>
                  <small>{truncateIssueText(item.currentIssue)}</small>
                </span>
                <span>
                  {item.nextAlertDate ? formatDashboardTimestamp(item.nextAlertDate) : 'No alert date'}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
